/**
 * This file will extend the stockists widget, adding the functionality for showing/hiding the opening times
 */
define([
    'jquery',
    'handlebars',
    'oldStockistsDirectory',
    'uiCollapse'
], function ($, Handlebars) {
    'use strict';
    

    Handlebars.registerHelper('replace', function(str, target, dest) {
        return str.replace(new RegExp(target, 'g'), dest);
    });

    $.widget('aligent.stockistsDirectory', $.aligent.stockistsDirectory, {
        _create: function () {
            this._super();
        },
        update: function () {
            this.itemContainers.removeClass('stockists-directory-list--ready');

            this._super();

            $('.stockists-directory__item').each(function () {
                var $stockistsDirectoryItem = $(this);
                var id = $stockistsDirectoryItem.attr('data-id');

                var $storeOpeningTimesTrigger = $('#store-opening-times-trigger-' + id);
                $storeOpeningTimesTrigger.uiCollapse({target: '#store-opening-times-' + id});

                //Update the text on the trigger to represent the action that will be taken when clicked
                $storeOpeningTimesTrigger.on('click', function() {
                    if ($('#store-opening-times-' + id).hasClass("_open")) {
                        $storeOpeningTimesTrigger.find(".directory-item__opening-times-trigger-verb").text("Hide")
                            .end().toggleClass('open').toggleClass('closed');
                    } else {
                        $storeOpeningTimesTrigger.find(".directory-item__opening-times-trigger-verb").text("View")
                            .end().toggleClass('open').toggleClass('closed');
                    }
                });

                // JS solution to make the height of all search results the same, whilst still allowing the height to
                // grow when the opening times are expanded.
                // See http://stackoverflow.com/a/28124692/6175643
                var containerHeight = $stockistsDirectoryItem.parent().height();
                $stockistsDirectoryItem.css('min-height', containerHeight + 'px');
                $stockistsDirectoryItem.find(".directory-item").css('min-height', containerHeight + 'px');

                //Push the opening times section to the bottom of the container.
                //Done this way as CSS solutions change the direction the section will expand when clicked
                var $openingTimesSection = $stockistsDirectoryItem.find(".directory-item__opening-times-container");
                if ($openingTimesSection.length === 0) {
                    return true;
                }

                var openingTimesHeight = $openingTimesSection.outerHeight();
                var stockistsDirectoryYposition = $stockistsDirectoryItem.offset().top;
                var openingTimesYposition = $openingTimesSection.offset().top;
                var containerBottomPosition = stockistsDirectoryYposition + ($stockistsDirectoryItem.outerHeight());
                var openingTimesRequiredYposition = containerBottomPosition - openingTimesHeight - 10;
                var difference = openingTimesRequiredYposition - openingTimesYposition;
                $openingTimesSection.css('margin-top', difference + "px");

                var content = $openingTimesSection.find(".collapse").html();
                var openingTimesArray = content.trim().split("\n");
                var openingTimes = '<ul class="directory-item__opening-times"><li>'+openingTimesArray.join("</li><li>")+'</li></ul>';
                $openingTimesSection.find(".collapse").html(openingTimes);
            });
            this.itemContainers.addClass('stockists-directory-list--ready');

        }
    });

    $.widget.bridge('aligent_stockistsDirectory', $.aligent.stockistsDirectory);
    return $.aligent.stockistsDirectory;
});
